import { SLOGANS } from "@/data/content";

export const Marquee = () => {
  const items = [...SLOGANS, ...SLOGANS];
  return (
    <section data-testid="slogan-marquee" className="bg-maroon py-6 md:py-8 overflow-hidden border-y border-maroon-light/40">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {items.map((s, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading italic text-3xl md:text-5xl text-cream px-8">{s}</span>
            <span className="text-gold text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
};
